<template>
  <div class="purchaseReceivesEdit">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="getTitle(resultStatus)"
        width="1000px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="purchase"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <table
            class="table"
            cellpadding="0"
            cellspacing="0"
            width="100%">
          <tr>
            <td v-if="purchase.status === 0 || purchase.status === 98" style="border-left: none;width: 33.2%">
              <span>编号:</span>{{purchase.no}}
            </td>
            <td v-if="purchase.status === 45 || purchase.status === 20" style="border-left: none">
              <span>编号:</span>{{purchase.no}}
            </td>
            <td v-if="purchase.status === 0 || purchase.status === 98" style="width: 66.5%">
              <span style="width: 13.2%">采购组:</span>{{purchase.buyUserName}}
            </td>
            <td v-if="purchase.status === 45 || purchase.status === 20">
              <span>采购组:</span>{{purchase.buyUserName}}
            </td>
            <td v-if="purchase.status === 45 || purchase.status === 20">
              <span>收货创建日期:</span>{{purchase.createdTime}}
            </td>
          </tr>
          <tr>
            <td style="border-left: none">
              <span>采购订单号:</span>{{purchase.buyOrderNO}}
            </td>
            <td>
              <span>供应商:</span>{{purchase.gysName}}
            </td>
            <td>
              <span>订单创建时间:</span>{{purchase.requiredArrivalDate}}
            </td>
          </tr>
          <tr>
            <td style="border-left: none;border-bottom: none">
              <span>联系人:</span>{{purchase.linkMan}}
            </td>
            <td style="border-bottom: none">
              <span>电话:</span>{{purchase.linkManPhone}}
            </td>
            <td style="border-bottom: none">
              <span>传真:</span>{{purchase.linkManFax}}
            </td>
          </tr>
        </table>

        <div style="border: 1px solid #f5f5f5;margin: 3% auto;padding: 2%;">
          <el-row>
            <el-col :span="12">
              <el-form-item v-if="purchase.status === 0 || purchase.status === 20 || purchase.status === 98" label="要求到货日期">
                <el-date-picker
                    v-model="purchase.plannedArrivalTime"
                    align="right"
                    type="date"
                    placeholder="选择日期"/>
              </el-form-item>
            </el-col>
            <el-col v-if="purchase.status === 20 || purchase.status === 45" :span="12">
              <el-form-item v-if="purchase.status === 20" label="实际到货日期">
                <el-date-picker
                    v-model="purchase.arrivedTime"
                    align="right"
                    type="date"
                    placeholder="选择日期"/>
              </el-form-item>
              <el-form-item v-if="purchase.status === 45" label="实际到货日期">
                <el-date-picker
                    v-model="purchase.arrivedTime"
                    align="right"
                    disabled
                    type="date"
                    placeholder="选择日期"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="purchase.status === 0 || purchase.status === 20 ||purchase.status === 98" label="备注">
            <el-input v-model="purchase.note" type="textarea" placeholder="请输入"/>
          </el-form-item>
          <el-form-item v-if="purchase.status === 45" label="备注">
            <el-input v-model="purchase.note" type="textarea" disabled placeholder="请输入"/>
          </el-form-item>
        </div>

        <div v-if="purchase.status === 0 || purchase.status === 98">
          <el-table
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column
                prop="rowIndex"
                align="center"
                label="序号"/>
            <el-table-column
                prop="sapmaterialNO"
                align="center"
                label="物料编号"/>
            <el-table-column
                prop="sapmaterialName"
                width="180px"
                align="center"
                label="物料名称"/>
            <el-table-column
                prop="requireDeliveryDate"
                width="180px"
                align="center"
                label="采购订单交期"/>
            <el-table-column
                prop="sumQuantity"
                align="center"
                label="采购数量"/>
            <el-table-column
                prop="sendedQuantity"
                align="center"
                label="已送数量"/>
            <el-table-column
                prop="quantity"
                align="center"
                label="送货数量">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.quantity"
                    align="center"
                    type="number"
                    min="1"
                    :max="scope.row.sumQuantity"/>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div v-if="purchase.status === 20">
          <el-table
              :data="tableData"
              border
              style="width: 100%">
            <el-table-column
                prop="rowIndex"
                align="center"
                label="序号"/>
            <el-table-column
                prop="sapmaterialNO"
                align="center"
                label="物料编号"/>
            <el-table-column
                prop="sapmaterialName"
                width="180px"
                align="center"
                label="物料名称"/>
            <el-table-column
                prop="requireDeliveryDate"
                width="180px"
                align="center"
                label="采购订单交期"/>
            <el-table-column
                prop="sumQuantity"
                align="center"
                label="采购数量"/>
            <el-table-column
                prop="sendedQuantity"
                align="center"
                label="已收数量"/>
            <el-table-column
                prop="receivedQuantity"
                align="center"
                label="收货数量">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.receivedQuantity"
                    align="center"
                    type="number"
                    min="1"
                    :max="scope.row.quantity"/>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-tabs v-if="purchase.status === 45" v-model="activeName" type="card">
          <el-tab-pane label="物料信息" name="first">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
              <el-table-column
                  prop="rowIndex"
                  align="center"
                  label="序号"/>
              <el-table-column
                  prop="sapmaterialNO"
                  align="center"
                  label="物料编号"/>
              <el-table-column
                  prop="sapmaterialName"
                  width="180px"
                  align="center"
                  label="物料名称"/>
              <el-table-column
                  prop="requireDeliveryDate"
                  width="180px"
                  align="center"
                  label="采购订单交期"/>
              <el-table-column
                  prop="quantity"
                  align="center"
                  label="采购数量"/>
              <el-table-column
                  prop="qualifiedQuantity"
                  align="center"
                  label="检验数量"/>
              <el-table-column
                  prop="instockQuantity"
                  align="center"
                  label="入库数量">
                <template slot-scope="scope">
                  <el-input
                      v-model="scope.row.instockQuantity"
                      align="center"
                      type="number"
                      min="1"
                      :max="scope.row.qualifiedQuantity"/>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="附件信息" name="second">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
              <el-table-column
                  prop="sapmaterialNO"
                  align="center"
                  label="文件分类"/>
              <el-table-column
                  prop="sapmaterialName"
                  width="180px"
                  align="center"
                  label="文件名"/>
              <el-table-column
                  prop="requireDeliveryDate"
                  width="180px"
                  align="center"
                  label="创建者"/>
              <el-table-column
                  prop="sumQuantity"
                  align="center"
                  label="创建时间"/>
              <el-table-column
                  label="操作"
                  align="center"
                  class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <preview ref="preview" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import Preview from "@/views/purchase/purchaseReceives/Preview";

  export default {
    name:"PurchaseReceivesEdit",
    components: {Preview},
    data() {
      return {
        constant,
        statu:constant.toSelect(constant.purchaseStatus,"addAll"),
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        tableData: [],
        activeName: "first",
        resultStatus: "",
        purchase: {
          pkid: "",
          no: "",
          purchaseOrderNO: "",
          buyOrderNO: "",
          status: "",
          receiveStatus: "",
          creatorName: "",
          createdTime: "",
          arrivedTime: "",
          gysName: "",
          buyUserName: "",
          linkMan: "",
          linkManFax: "",
          linkManPhone: "",
          requiredArrivalDate: "",
          plannedArrivalTime: "",
          planAddDateBegin: "",
          planAddDateEnd: "",
          autcalDateBegin: "",
          autcalDateEnd: "",
          receiveDetails: [],
        },
        ruleValidate: {
          postName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        console.log(row);
        this.purchase.pkid = row.pkid;
        this.resultStatus = row.status;
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http
          .get("basic", `purchaseReceives/${this.purchase.pkid}`)
          .then(resp => {
            this.purchase = resp;
            for(let item of resp.receiveDetails) {
              item.receivedQuantity = item.quantity;
            }
            this.tableData = resp.receiveDetails;
          });
      },
      getTitle(val) {
        switch (val) {
          case 0: return "编辑";
          case 20: return "确认收货";
          case 45: return "入库编辑";
        }
      },
      oneDelete(index) {
        this.tableData[index].isRemove = 1;
        this.tableData.splice(index,1);
      },
      handleSubmit() {
        if(this.purchase.status === 0 || this.purchase.status === 98) {
          for(let item of this.tableData) {
            if(item.quantity<1 || item.quantity > item.sumQuantity) {
              this.$message.error("送货数量不能小于1也不能超过采购数量");
              return;
            }
          }
          this.purchase.receiveDetails = this.tableData;
          this.handleSubmits();
        }
        else if(this.purchase.status === 20) {
          for (let item of this.tableData) {
            if(item.receivedQuantity < 1 || item.receivedQuantity > item.quantity) {
              this.$message.error("收货数量不能小于1也不能大于送货数量");
              return;
            }
          }
          this.purchase.receiveDetails = this.tableData;
          this.handleSubmitReceiving();
        }else {
          for(let item of this.tableData) {
            if(item.instockQuantity < 1 || item.instockQuantity > item.qualifiedQuantity) {
              this.$message.error("入库数量不能小于1也不能大于检验数量");
              return;
            }
          }
          this.purchase.receiveDetails = this.tableData;
          this.handleSubmitStorage();
        }

      },
      //发货编辑
      handleSubmits() {
        this.$refs.form.validate(valid => {
          this.submitLoading = true;
          if(valid) {
            this.$http
              .post("basic", "purchaseReceives/updateSendPurchase", this.purchase)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      //收货编辑
      handleSubmitReceiving() {
        this.$refs.form.validate(valid => {
          this.submitLoading = true;
          if(valid) {
            this.$http
              .post("basic", "purchaseReceives/updateReceivePurchase", this.purchase)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      //入库编辑
      handleSubmitStorage() {
        this.$refs.form.validate(valid => {
          this.submitLoading = true;
          if(valid) {
            this.$http
              .post("basic", "purchaseReceives/updateInstockPurchase", this.purchase)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
    .purchaseReceivesEdit{
        .el-form-item__content{
            margin-left: 2%!important;
        }
        .table{
            width: 100%;
            border: 1px solid #cccccc;
            margin-bottom: 3%;
            tr{
                display: flex;
                flex-direction: row;
                td{
                    width: 33.5%;
                    height: 40px;
                    line-height: 40px;
                    border-left: 1px solid #cccccc;
                    border-bottom: 1px solid #cccccc;
                    display: flex;
                    flex-direction: row;
                    padding: 0;
                    span{
                        display: block;
                        padding-right: 2%;
                        margin-right: 2%;
                        width: 28%;
                        height: 40px;
                        line-height: 40px;
                        background: #f5f5f5;
                        border-right: 1px solid #cccccc;
                        text-align: right;
                    }
                }
            }
        }
    }

</style>
